import detectAndroidVersion from "./detectAndroidVersion";
import detectChromeVersion from "./detectChromeVersion";
import detectIosVersion from "./detectIosVersion";
import detectModulesSupportedInWorker from "./detectModulesSupportedInWorker";
import detectSafariVersion from "./detectSafariVersion";
import hasDrawingContext from "./hasDrawingContext";
let iosVersion = null;
let safariVersion = null;
let supportsModulesInWorker = null;
let supportsWebGL = null;
let supportsWebGL2 = null;
let androidVersion = null;
let chromeVersion = null;
export const BrowserDetection = {
    get iOSVersion() {
        if (iosVersion == null) {
            iosVersion = detectIosVersion();
        }
        return iosVersion;
    },
    get safariVersion() {
        if (safariVersion == null) {
            safariVersion = detectSafariVersion();
        }
        return safariVersion;
    },
    get modulesSupportedInWorker() {
        if (supportsModulesInWorker == null) {
            supportsModulesInWorker = detectModulesSupportedInWorker();
        }
        return supportsModulesInWorker;
    },
    get webGL() {
        if (supportsWebGL == null) {
            supportsWebGL = hasDrawingContext("webgl") || hasDrawingContext("experimental-webgl");
        }
        return supportsWebGL;
    },
    get webGL2() {
        if (supportsWebGL2 == null) {
            supportsWebGL2 = hasDrawingContext("webgl2");
        }
        return supportsWebGL2;
    },
    get androidVersion() {
        if (androidVersion == null) {
            androidVersion = detectAndroidVersion();
        }
        return androidVersion;
    },
    get chromeVersion() {
        if (chromeVersion == null) {
            chromeVersion = detectChromeVersion();
        }
        return chromeVersion;
    }
};
